import * as React from 'react'

import { QuoteNavigation } from './Navigation'
import { QuoteContext } from './QuoteContext'
import { Perf } from './components/ComparePerformance'
import { InsiderTradingVolumeChart } from './components/InsiderTradingChart'
import { QuotePortal } from './components/Portal'
import { ChartContextQuoteHeader, ManualInitQuoteHeader } from './components/Price'
import { QuoteChart } from './components/QuoteChart'
import Statements from './components/Statements/statements'
import { StaticChartHeader } from './components/StaticChartHeader'
import FundamentalCharts from './components/fundamentalCharts'
import EtfHoldings from './etf-holdings'
import { QuoteSubview, QuoteView } from './types'

const PRICE_STATIC = document.querySelectorAll('.js-quote-price-static')
const PRICE_ROOTS = document.querySelectorAll('.js-quote-price-root')

const NAVIGATION_STATIC = document.querySelectorAll('.js-quote-navigation-static')
const NAVIGATION_ROOTS = document.querySelectorAll('.js-quote-navigation-root')

const ETF_HOLDINGS_STATIC = document.querySelectorAll('.js-etf-holdings-static')
const ETF_HOLDINGS_ROOTS = document.querySelectorAll('.js-etf-holdings-root')
const isETF = !!ETF_HOLDINGS_ROOTS.length

const STATIC_CHART_HEADER_ROOTS = document.querySelectorAll('.quote-menu')

const FUNDAMENTAL_CHARTS_ROOTS = document.querySelectorAll('.js-quote-fa')

const STATEMENTS_ROOTS = document.querySelectorAll('#statements')

const INSIDER_CHART_ROOTS = document.querySelectorAll('.insider-trading-chart')

export function QuotePortalComponents({ isStockDetailUpdating }: { isStockDetailUpdating: boolean }) {
  const context = React.useContext(QuoteContext)

  return (
    <>
      {context.index === 0 && !window.isIdeaNotFoundPage && (
        <QuotePortal staticElements={PRICE_STATIC} roots={PRICE_ROOTS} toggleStaticElement={false}>
          <React.Suspense fallback={null}>
            {context.view === QuoteView.ChartDetail || context.subview === QuoteSubview.ShortInterest ? (
              <ChartContextQuoteHeader />
            ) : (
              <ManualInitQuoteHeader config={window.globalChartConfig} />
            )}
          </React.Suspense>
        </QuotePortal>
      )}

      <QuotePortal staticElements={NAVIGATION_STATIC} roots={NAVIGATION_ROOTS} toggleStaticElement={false}>
        <QuoteNavigation />
      </QuotePortal>

      {context.view === QuoteView.ChartDetail && (
        <React.Suspense fallback={null}>
          {context.index === 0 && <QuoteChart />}

          {context.index > 0 && (
            <QuotePortal
              roots={STATIC_CHART_HEADER_ROOTS}
              // We need to subtract here, because the first ticker doesn’t have this component
              index={context.index - 1}
            >
              <StaticChartHeader isStockDetailUpdating={isStockDetailUpdating} />
            </QuotePortal>
          )}
        </React.Suspense>
      )}

      {context.subview === QuoteSubview.ComparePerf && window.FinvizQuoteTickers && context.index === 0 && <Perf />}

      <QuotePortal staticElements={ETF_HOLDINGS_STATIC} roots={ETF_HOLDINGS_ROOTS}>
        <EtfHoldings />
      </QuotePortal>

      <QuotePortal
        roots={FUNDAMENTAL_CHARTS_ROOTS}
        // Roots for this element don’t render on ETFs
        index={isETF ? context.index - 1 : undefined}
      >
        <FundamentalCharts />
      </QuotePortal>

      <QuotePortal roots={STATEMENTS_ROOTS}>
        <Statements />
      </QuotePortal>

      <QuotePortal roots={INSIDER_CHART_ROOTS}>
        <InsiderTradingVolumeChart className="my-6" />
      </QuotePortal>
    </>
  )
}
